import { combineReducers } from '@reduxjs/toolkit'
import auth from "./auth/reducers";
import company from "./company/reducers";

const rootReducer = combineReducers({
  auth: auth,
  company: company,
})

export default rootReducer
